import {getLocale, setLocale} from '@locale';
import {LAN_EN_KEY, LAN_ZH_KEY} from './constant';
// import {updateVersions} from '../versions';
import {getLandingVersions} from '~/Configuration/LandingPage';
import {getTutorialVersions} from '~/Configuration/Tutorial';
import libLocale from '@enos/dpl/lib/locale';
import libdplen from '@enos/dpl/lib/locale/lang/en_US';
import libdplzh from '@enos/dpl/lib/locale/lang/zh_CN';

export function enableDplLang() {
  if (libLocale && libLocale.use) {
    if (getLocale() === 'zh-CN') {
      libLocale.use(libdplzh);
    } else {
      libLocale.use(libdplen);
    }
  }
}

export function splitLocale(source) {
  const locale = getLocale().replace(/-/, '_');
  if (!source) {
    return '';
  }
  return source[locale] || source.default;
}

// export function getFolder(locale) {
//   const versions = updateVersions(locale);
//   return versions;
// }

export function getLandingConfig(locale) {
  const versions = getLandingVersions(locale);
  return versions;
}
export function getTutorialConfig(locale) {
  const versions = getTutorialVersions(locale);
  return versions;
}

export function getLanguageKey() {
  const locale = getLocale();

  if (locale === 'en-US') {
    return LAN_EN_KEY;
  }

  if (locale === 'zh-CN') {
    return LAN_ZH_KEY;
  }

  return '';
}

export function setLanguage(key) {
  let sKey = 'zh-CN';
  if (key === LAN_EN_KEY) {
    sKey = 'en-US';
  }
  setLocale(sKey);
  window.localStorage.setItem('locale', sKey);
  // setLocaleToCookie(sKey);
  enableDplLang();
}

export function switchLocale(key) {
  if (key !== getLocale()) {
    setLocale(key);
    window.localStorage.setItem('locale', key);
    // setLocaleToCookie(key);
    window.location.reload();
  }
}

export function compareVersion(version1, version2) {
  const v1 = version1.split('.');
  const v2 = version2.split('.');

  while (v1.length !== 0 || v2.length !== 0) {
    const mVers1 = parseInt(v1.shift() || '0') || 0;
    const mVers2 = parseInt(v2.shift() || '0') || 0;
    if (mVers1 !== mVers2) {
      return mVers1 > mVers2 ? version1 : version2;
    }
  }
  return version1;
}

export function getLatestVersion(versionList) {
  if (!versionList || !versionList.length) {
    return '0.0.0';
  }
  if (versionList.length === 1) {
    return versionList[0];
  }
  if (versionList.length === 2) {
    return compareVersion(versionList[0], versionList[1]);
  }
  let maxVersion = '0.0.0';
  versionList.forEach((v) => {
    maxVersion = compareVersion(v, maxVersion);
  });
  return maxVersion;
}

export function getLocaleString(localeValue) {
  const locale = getLocale();
  if (typeof localeValue === 'object' && localeValue !== null) {
    return localeValue?.[locale]
    || localeValue?.i18nValue?.[locale]
    || localeValue?.[locale.replace?.('-', '_')]
    || localeValue?.i18nValue?.[locale.replace?.('-', '_')]
    || localeValue?.default
    || localeValue?.defaultValue;
  }
  return localeValue;
}
